import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import TodoList from './TodoList';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'todolist',
    name: 'TodoList',
    component: TodoList,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('todo-list', {
//   path: '/app/todolist',
//   text: 'To Do List',
//   uuid: 'Todo List',
//   permission: 'write',
//   weight: -1,
//   icon: ['fas', 'list-ul']
// }));
